module.exports = __webpack_public_path__ + "static/img/goods-merchandise2.291b2c4d.jpg";